import { config } from '@/components/atomic/templates/navigation/column-layout/config';
import loadableRetry from '@/utils/loadable-retry';
import {
	EditableComponent,
	EditableComponentProps,
} from '@adobe/aem-react-editable-components';
import loadable from '@loadable/component';

const ColumnLayout = loadable(() =>
	loadableRetry(
		() =>
			import(
				'@/components/atomic/templates/navigation/column-layout/column-layout'
			),
	),
);

const component = (props: EditableComponentProps) => {
	return (
		<EditableComponent config={config} {...props}>
			<ColumnLayout {...(props as any)} />
		</EditableComponent>
	);
};

export default component;
